import { DefaultButton, Dialog, DialogFooter, Text } from '@fluentui/react';
import React, { useEffect, useState, ReactElement } from 'react';

import { useHistory, useLocation } from 'react-router';
import { GroupRoleComponent } from '../groupRole/';
import { BaseTab } from './BaseTab';

export const isNewQueueKey = 'isNewQueue';

export const AccessTab = (): ReactElement => {
  // True means show the modal, undefined means hide the modal there's no reason to even talk about it,
  // and false means hide the modal we're done with it.
  const [showNewQueueModal, setShowNewQueueModal] = useState<boolean | undefined>();
  const { search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(search);
    if (params.get(isNewQueueKey)) {
      setShowNewQueueModal(true);
    }
  }, [search]);

  useEffect(() => {
    if (showNewQueueModal === false) {
      const params = new URLSearchParams(search);
      params.delete(isNewQueueKey);
      history.push({ search: params.toString() });
    }
  }, [showNewQueueModal, search]);

  return (
    <BaseTab>
      <GroupRoleComponent />
      <Dialog
        isBlocking={false}
        hidden={!showNewQueueModal}
        dialogContentProps={{
          title: 'New Queue'
        }}
        modalProps={{
          overlay: {
            isDarkThemed: true
          }
        }}
      >
        <Text>{`Your queue has been created! But no one has access to it yet. Take a minute to add your groups and set the approptiate roles. Remember to perform an RBAC Sync when you're done.`}</Text>

        <DialogFooter>
          <DefaultButton onClick={() => setShowNewQueueModal(false)} text={'Done'} />
        </DialogFooter>
      </Dialog>
    </BaseTab>
  );
};
